import React, { useMemo } from 'react';
import { Modal, Icon, FlexCrate, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';

const getCopy = copyFor(
  'settings.paymentInformation.addPaymentMethodModal.screens.error'
);
interface Props {
  close: () => void;
  context: AddPaymentMethodContext;
}

export const Error = ({ close, context }: Props) => {
  const copy = useMemo(() => {
    if (context.errors?.setPaymentMethod) return getCopy('setPaymentMethod');
    if (context.errors?.paymentHold) return getCopy('paymentHold');
    return getCopy('generic');
  }, [context.errors]);

  return (
    <>
      <Modal.Header title="" onClose={close} />
      <Modal.Content>
        <FlexCrate
          flexDirection="column"
          minHeight="400px"
          alignItems="center"
          justifyContent="center"
        >
          <Icon
            icon="ExclamationCircleInverted"
            margin={{ bottom: '16px' }}
            scale={3}
          />
          {copy.map(line => (
            <Text key={line} margin={{ bottom: '16px' }}>
              {line}
            </Text>
          ))}
        </FlexCrate>
      </Modal.Content>
    </>
  );
};
